import * as React from 'react';
import {
    SunIconSvg,
    CheckedIconSvg,
    UncheckedIconSvg,
    PaperPlaneBlackIconSvg,
    EditIconSvg,
    LikeIconSvg,
    UndoIconSvg,
    ShareIconSvg,
    YouTubeIconSvg,
    InstagramIconSvg,
    CalendarIconSvg,
    SuitcaseIconSvg,
    LayoutIconSvg,
    FlashIconSvg
} from '../SvgImports';

export const SunIcon = () => <img alt="Sun icon" className="svgIcon" src={SunIconSvg} />;
export const PlaneIcon = () => <img alt="Plane icon" className="svgIcon" src={PaperPlaneBlackIconSvg} />;
export const CheckedIcon = () => <img alt="Checked icon" className="svgIcon checkedIcon" src={CheckedIconSvg} title="Accept" />;
export const UncheckedIcon = () => <img alt="Unchecked icon" className="svgIcon uncheckedIcon" src={UncheckedIconSvg} title="Remove" />;
export const EditIcon = () => <img alt="Edit icon" className="svgIcon editIcon" src={EditIconSvg} title="Edit" />;
export const HeartIcon = () => <img alt="Heart icon" className="svgIcon" src={LikeIconSvg} title="Like" />;
export const UndoIcon = () => <img alt="Undo icon" className="svgIcon undoIcon" src={UndoIconSvg} title="Undo" />;
export const ShareIcon = () => <img alt="Share icon" className="svgIcon shareIcon" src={ShareIconSvg} title="Share" />;
export const YouTubeIcon = () => <img alt="YouTube" className="svgIcon youTubeIcon" src={YouTubeIconSvg} title="YouTube" />;
export const InstagramIcon = () => <img alt="Instagram" className="svgIcon instagramIcon" src={InstagramIconSvg} title="Instagram" />;
export const CalendarIcon = () => <img alt="Calendar icon" className="svgIcon" src={CalendarIconSvg} title="Calendar" />;
export const JobsIcon = () => <img alt="Jobs icon" className="svgIcon" src={SuitcaseIconSvg} title="Jobs" />;
export const ListingIcon = () => <img alt="Listing icon" className="svgIcon" src={LayoutIconSvg} title="Listing" />;
export const FlashIcon = ({ title }: { title?: string }) => <img alt="Flash icon" className="svgIcon" src={FlashIconSvg} title={title || 'Flash'} />;

export const TickSymbol = () => <>&#10003;</>;